import CustomTable from "Components/CustomTable/CustomTable";
import { useSelector } from "react-redux";
import { getCommonColumns } from "Components/CustomTable/Commons";
import CountryAddEditForm from "Components/Forms/Master/Countries/CountryAddEditForm";
import getPermittedColumns from "Utils/getPermittedColumns";

const apiUrl = "/user/rest/countries";
const headerTitle = "Countries";
const editPermission = "countries:edit";
const deletePermission = "countries:delete";
const addPermission = "countries:add";

const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        // render: (text) => <a>{text}</a>,
    },
    {
        title: 'Code',
        dataIndex: 'code',
        key: 'code',
        // render: (text) => <a>{text}</a>,
    },
    {
        title: 'Phone Code',
        dataIndex: 'phone_code',
        key: 'phone_code',
        // render: (text) => <a>{text}</a>,
    },
    ...getCommonColumns({ apiUrl, editPermission, deletePermission, created: true, updated: true, action: true })
]

const CountriesPage = () => {

    const userPermissions = useSelector(store => store.auth?.user?.permissions);
    let _columns = getPermittedColumns(columns, userPermissions, editPermission, deletePermission);

    return <CustomTable
        columns={_columns}
        apiUrl={apiUrl}
        headerTitle={headerTitle}
        MyFormComponent={CountryAddEditForm}
        addPermissionNames={[addPermission]}
    />;
}

export default CountriesPage;